import React from 'react';
import './PageCard.css';

function HowToTrade() {
  return (
    <div className="page-card">
      <h2 className="page-title">How to Trade</h2>
      <div className="page-section">
        Step 1: Register and sign in to your account.<br />
        Step 2: Fund your account.<br />
        Step 3: Go to Place Trades and select your trading options.<br />
        Step 4: Monitor your trades and review your metrics.
      </div>
    </div>
  );
}

export default HowToTrade;
